<mat-form-field appearance="fill" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" matTooltipPosition="above"
  matTooltipClass="sbm-tooltip">

  <mat-label>
    <app-required *ngIf="isRequired()"></app-required> {{label}}
  </mat-label>

  <textarea matInput [formControl]="control" [placeholder]="placeholder? placeholder: ''" [rows]="rows?rows:''"
    [maxlength]="charCount?charCount: maxlength?maxlength:''"></textarea>

  <ng-container *ngIf="control && control.invalid" ngProjectAs="mat-error">
    <mat-error *ngIf="control.hasError('required')">
      {{label}} is <strong>required</strong>.
    </mat-error>
  </ng-container>

  <ng-container ngProjectAs="mat-hint">
    <mat-hint *ngIf="hint">{{hint}}</mat-hint>
  </ng-container>
  <mat-hint *ngIf="charCount" align="end">Characters Count {{control.value?.length || 0}}/{{charCount}}</mat-hint>
  <mat-hint *ngIf="maxWords" align="end">Word count {{wordCount}}/{{maxWords}}</mat-hint>

</mat-form-field>
